(function() {

angular.module('ngmvac').
directive('bricklayer', function() {
    return {
        restrict: 'A',
        
        link: function(scope, element, attrs){
            var bricklayer = new Bricklayer(document.getElementById('my-bricklayer'));
        }
    };
});

})();